import {
  type DashRouteType,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/route-patterns'

const URL_INSIGHTS_PORTAL = `${URL_RETAILER_SCOPED}/insights-portal`
const URL_INSIGHTS_PORTAL_REDIRECT_PAGE = `${URL_INSIGHTS_PORTAL}/redirect-page`

// Store performance
const URL_INSIGHTS_PORTAL_STORE_PERFORMANCE = `${URL_INSIGHTS_PORTAL}/store-performance`
const URL_INSIGHTS_PORTAL_COMPLETED_ORDERS = `${URL_INSIGHTS_PORTAL_STORE_PERFORMANCE}/completed-orders`
const URL_INSIGHTS_PORTAL_STORE_PERFORMANCE_BASKET_OVERVIEW = `${URL_INSIGHTS_PORTAL_STORE_PERFORMANCE}/basket/overview`
const URL_INSIGHTS_PORTAL_STORE_PERFORMANCE_BASKET_OUT_OF_STOCK = `${URL_INSIGHTS_PORTAL_STORE_PERFORMANCE}/basket/out-of-stock`
const URL_INSIGHTS_PORTAL_STORE_PERFORMANCE_SEARCH = `${URL_INSIGHTS_PORTAL_STORE_PERFORMANCE}/search`
const URL_INSIGHTS_PORTAL_STORE_PERFORMANCE_IMAGE_COVERAGE = `${URL_INSIGHTS_PORTAL_STORE_PERFORMANCE}/image-coverage`

// Executive summary dashboard
const URL_INSIGHTS_PORTAL_EXECUTIVE_SUMMARY = `${URL_INSIGHTS_PORTAL}/executive-summary`

// Collections insights
const URL_INSIGHTS_PORTAL_MERCHANDISING = `${URL_INSIGHTS_PORTAL}/merchandising`
const URL_INSIGHTS_PORTAL_MERCHANDISING_COLLECTIONS_OVERVIEW = `${URL_INSIGHTS_PORTAL_MERCHANDISING}/collections/overview`
const URL_INSIGHTS_PORTAL_MERCHANDISING_COLLECTIONS_PRODUCT_CAROUSELS = `${URL_INSIGHTS_PORTAL_MERCHANDISING}/collections/product-carousels`
const URL_INSIGHTS_PORTAL_MERCHANDISING_COLLECTIONS_SINGLE_COLLECTION = `${URL_INSIGHTS_PORTAL_MERCHANDISING}/collections/single-collection`
const URL_INSIGHTS_PORTAL_MERCHANDISING_COLLECTIONS_DEPARTMENTS = `${URL_INSIGHTS_PORTAL_MERCHANDISING}/collections/departments`
const URL_INSIGHTS_PORTAL_MERCHANDISING_COLLECTIONS_PAGE = `${URL_INSIGHTS_PORTAL_MERCHANDISING}/collections/page`

// Campaigns with offers
const URL_INSIGHTS_PORTAL_MARKETING = `${URL_INSIGHTS_PORTAL}/marketing`
const URL_INSIGHTS_PORTAL_MARKETING_CAMPAIGNS_OVERVIEW = `${URL_INSIGHTS_PORTAL_MARKETING}/campaigns/overview`
const URL_INSIGHTS_PORTAL_MARKETING_CAMPAIGNS_REDEMPTIONS_IN_APP = `${URL_INSIGHTS_PORTAL_MARKETING}/campaigns/redemptions-in-app`
const URL_INSIGHTS_PORTAL_MARKETING_CAMPAIGNS_USER_GROWTH = `${URL_INSIGHTS_PORTAL_MARKETING}/campaigns/user-growth`
const URL_INSIGHTS_PORTAL_MARKETING_CAMPAIGNS_BASKET = `${URL_INSIGHTS_PORTAL_MARKETING}/campaigns/basket`

// Campaigns without offers
const URL_INSIGHTS_PORTAL_MARKETING_AWARENESS_CAMPAIGNS_OVERVIEW = `${URL_INSIGHTS_PORTAL_MARKETING}/awareness-campaigns/overview`
const URL_INSIGHTS_PORTAL_MARKETING_AWARENESS_CAMPAIGNS_BASKET_IMPACT = `${URL_INSIGHTS_PORTAL_MARKETING}/awareness-campaigns/basket-impact`
const URL_INSIGHTS_PORTAL_MARKETING_AWARENESS_CAMPAIGNS_FUNNEL_DATA = `${URL_INSIGHTS_PORTAL_MARKETING}/awareness-campaigns/funnel-data`

// Flyers
const URL_INSIGHTS_PORTAL_MARKETING_FLYERS_OVERVIEW = `${URL_INSIGHTS_PORTAL_MARKETING}/flyers/overview`
const URL_INSIGHTS_PORTAL_MARKETING_FLYERS_SINGLE_FLYER = `${URL_INSIGHTS_PORTAL_MARKETING}/flyers/single-flyer`

// Creatives
const URL_INSIGHTS_PORTAL_PLACEMENTS_INSIGHTS = `${URL_INSIGHTS_PORTAL}/placements-insights`

// Custom reports
const URL_INSIGHTS_PORTAL_REPORTS_LOGS = `${URL_INSIGHTS_PORTAL}/reports-logs`
const URL_INSIGHTS_PORTAL_REPORTS_LOGS_CUSTOM_REPORT = `${URL_INSIGHTS_PORTAL_REPORTS_LOGS}/custom-report`
const URL_INSIGHTS_PORTAL_REPORTS_LOGS_CUSTOM_REPORT_LIST = `${URL_INSIGHTS_PORTAL_REPORTS_LOGS_CUSTOM_REPORT}/reports/list`
const URL_INSIGHTS_PORTAL_REPORTS_LOGS_CUSTOM_REPORT_EXPORTS_LIST = `${URL_INSIGHTS_PORTAL_REPORTS_LOGS_CUSTOM_REPORT}/exports/list`
const URL_INSIGHTS_PORTAL_REPORTS_LOGS_CUSTOM_REPORT_PREVIEW = `${URL_INSIGHTS_PORTAL_REPORTS_LOGS_CUSTOM_REPORT}/preview/`

// Ads dashboard
const URL_INSIGHTS_PORTAL_ADS_DASHBOARD = `${URL_INSIGHTS_PORTAL}/ads-dashboard`
const URL_INSIGHTS_PORTAL_SPONSORED_PRODUCT_ADS_DASHBOARD = `${URL_INSIGHTS_PORTAL}/ads-dashboard/sponsored-product`
const URL_INSIGHTS_PORTAL_DISPLAY_ADS_DASHBOARD = `${URL_INSIGHTS_PORTAL}/ads-dashboard/display`
const URL_INSIGHTS_PORTAL_OVERVIEW_ADS_DASHBOARD = `${URL_INSIGHTS_PORTAL}/ads-dashboard/overview`
const URL_INSIGHTS_PORTAL_DISPLAY_PREVIEW_BLOCKING_TOOL = `${URL_INSIGHTS_PORTAL}/display-preview-blocking-tool`

// Store labor performance
const URL_INSIGHTS_PORTAL_STORE_LABOR_PERFORMANCE_V2 = `${URL_INSIGHTS_PORTAL}/reports/store-labor-performance`

// Cart Assistant dashboard
const URL_INSIGHTS_PORTAL_CART_ASSISTANT_DASHBOARD = `${URL_INSIGHTS_PORTAL}/cart-assistant-dashboard`

// Caper reporting dashboard
const URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD = `${URL_INSIGHTS_PORTAL}/caper-reporting-dashboard`
const URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_OVERVIEW = `${URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD}/overview`
const URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_SESSIONS = `${URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD}/sessions`
const URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_SESSION_TRENDS = `${URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD}/session-trends`
const URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_STORE_TREND = `${URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD}/store-trend`
const URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_AUDITS = `${URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD}/audits`
const URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_LOYALTY = `${URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD}/loyalty`
const URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_OPERATIONS = `${URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD}/operations`
const URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_STORE_PERFORMANCE = `${URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD}/store-performance`
const URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_SESSION_DETAILS = `${URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD}/session-details`

const URL_INSIGHTS_PORTAL_DELIVERY_PERFORMANCE = `${URL_INSIGHTS_PORTAL}/delivery-performance`
const URL_INSIGHTS_PORTAL_DELIVERY_PERFORMANCE_OVERVIEW = `${URL_INSIGHTS_PORTAL_DELIVERY_PERFORMANCE}/overview`
const URL_INSIGHTS_PORTAL_DELIVERY_PERFORMANCE_DELIVERY = `${URL_INSIGHTS_PORTAL_DELIVERY_PERFORMANCE}/delivery`

// Offer ingestion
const URL_INSIGHTS_PORTAL_OFFER_INGESTION = `${URL_INSIGHTS_PORTAL}/offer-ingestion`
const URL_INSIGHTS_PORTAL_OFFER_INGESTION_SUMMARY = `${URL_INSIGHTS_PORTAL_OFFER_INGESTION}/summary`
const URL_INSIGHTS_PORTAL_OFFER_INGESTION_SEARCH = `${URL_INSIGHTS_PORTAL_OFFER_INGESTION}/search`
const URL_INSIGHTS_PORTAL_OFFER_INGESTION_SUPPORTED_OFFERS = `${URL_INSIGHTS_PORTAL_OFFER_INGESTION}/supported-offers`
// Delivery Orchestration Performance
const URL_INSIGHTS_PORTAL_DELIVERY_ORCHESTRATION_PERFORMANCE = `${URL_INSIGHTS_PORTAL}/delivery-orchestration-performance`
const URL_INSIGHTS_PORTAL_DELIVERY_ORCHESTRATION_PROVIDER_DRILLDOWN = `${URL_INSIGHTS_PORTAL_DELIVERY_ORCHESTRATION_PERFORMANCE}/provider-drilldown`

// @hygen:inject scoped-urls

// @hygen:inject admin-urls

export type DashRouteSet =
  | DashRouteType<'insights-portal'>
  | DashRouteType<'insights-portal-redirect-page'>
  | DashRouteType<'insights-portal-store-performance-completed-orders'>
  | DashRouteType<'insights-portal-store-performance-basket-overview'>
  | DashRouteType<'insights-portal-store-performance-basket-out-of-stock'>
  | DashRouteType<'insights-portal-store-performance-search'>
  | DashRouteType<'insights-portal-store-performance-image-coverage'>
  | DashRouteType<'insights-portal-executive-summary'>
  | DashRouteType<'insights-portal-merchandising-collections-overview'>
  | DashRouteType<'insights-portal-merchandising-collections-product-carousel'>
  | DashRouteType<'insights-portal-merchandising-collections-single-collection'>
  | DashRouteType<'insights-portal-merchandising-collections-departments'>
  | DashRouteType<'insights-portal-merchandising-collections-page'>
  | DashRouteType<'insights-portal-marketing-campaigns-analytics-overview'>
  | DashRouteType<'insights-portal-marketing-campaigns-analytics-redemptions-in-app'>
  | DashRouteType<'insights-portal-marketing-campaigns-analytics-user-growth'>
  | DashRouteType<'insights-portal-marketing-campaigns-analytics-basket-impact'>
  | DashRouteType<'insights-portal-marketing-awareness-campaigns-analytics-overview'>
  | DashRouteType<'insights-portal-marketing-awareness-campaigns-analytics-basket-impact'>
  | DashRouteType<'insights-portal-marketing-awareness-campaigns-analytics-funnel-data'>
  | DashRouteType<'insights-portal-marketing-flyers-overview'>
  | DashRouteType<'insights-portal-marketing-flyers-single-flyer'>
  | DashRouteType<'insights-portal-placements-insights'>
  | DashRouteType<'insights-portal-reports-logs-custom-report-list'>
  | DashRouteType<'insights-portal-reports-logs-custom-report-exports-list'>
  | DashRouteType<'insights-portal-reports-logs-custom-report-preview'>
  | DashRouteType<'insights-portal-ads-dashboard'>
  | DashRouteType<'insights-portal-sponsored-product-ads-dashboard'>
  | DashRouteType<'insights-portal-display-ads-dashboard'>
  | DashRouteType<'insights-portal-overview-ads-dashboard'>
  | DashRouteType<'insights-portal-display-preview-blocking-tool'>
  | DashRouteType<'insights-portal-store-labor-performance-v2'>
  | DashRouteType<'insights-portal-cart-assistant-dashboard'>
  | DashRouteType<'insights-portal-caper-reporting-dashboard'>
  | DashRouteType<'insights-portal-caper-reporting-dashboard-overview'>
  | DashRouteType<'insights-portal-caper-reporting-dashboard-sessions'>
  | DashRouteType<'insights-portal-caper-reporting-dashboard-session-trends'>
  | DashRouteType<'insights-portal-caper-reporting-dashboard-store-trend'>
  | DashRouteType<'insights-portal-caper-reporting-dashboard-audits'>
  | DashRouteType<'insights-portal-caper-reporting-dashboard-loyalty'>
  | DashRouteType<'insights-portal-caper-reporting-dashboard-operations'>
  | DashRouteType<'insights-portal-caper-reporting-dashboard-store-performance'>
  | DashRouteType<'insights-portal-caper-reporting-dashboard-session-details'>
  | DashRouteType<'insights-portal-delivery-performance'>
  | DashRouteType<'insights-portal-delivery-performance-overview'>
  | DashRouteType<'insights-portal-delivery-performance-delivery'>
  | DashRouteType<'insights-portal-offer-ingestion'>
  | DashRouteType<'insights-portal-offer-ingestion-summary'>
  | DashRouteType<'insights-portal-offer-ingestion-search'>
  | DashRouteType<'insights-portal-offer-ingestion-supported-offers'>
  | DashRouteType<'insights-portal-delivery-orchestration-performance'>
  | DashRouteType<'insights-portal-delivery-orchestration-provider-drilldown'>

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'insights-portal': URL_INSIGHTS_PORTAL,
  'insights-portal-redirect-page': URL_INSIGHTS_PORTAL_REDIRECT_PAGE,

  'insights-portal-store-performance-completed-orders': URL_INSIGHTS_PORTAL_COMPLETED_ORDERS,
  'insights-portal-store-performance-basket-overview':
    URL_INSIGHTS_PORTAL_STORE_PERFORMANCE_BASKET_OVERVIEW,
  'insights-portal-store-performance-basket-out-of-stock':
    URL_INSIGHTS_PORTAL_STORE_PERFORMANCE_BASKET_OUT_OF_STOCK,
  'insights-portal-store-performance-search': URL_INSIGHTS_PORTAL_STORE_PERFORMANCE_SEARCH,
  'insights-portal-store-performance-image-coverage':
    URL_INSIGHTS_PORTAL_STORE_PERFORMANCE_IMAGE_COVERAGE,

  'insights-portal-executive-summary': URL_INSIGHTS_PORTAL_EXECUTIVE_SUMMARY,

  'insights-portal-merchandising-collections-overview':
    URL_INSIGHTS_PORTAL_MERCHANDISING_COLLECTIONS_OVERVIEW,
  'insights-portal-merchandising-collections-product-carousel':
    URL_INSIGHTS_PORTAL_MERCHANDISING_COLLECTIONS_PRODUCT_CAROUSELS,
  'insights-portal-merchandising-collections-single-collection':
    URL_INSIGHTS_PORTAL_MERCHANDISING_COLLECTIONS_SINGLE_COLLECTION,
  'insights-portal-merchandising-collections-departments':
    URL_INSIGHTS_PORTAL_MERCHANDISING_COLLECTIONS_DEPARTMENTS,
  'insights-portal-merchandising-collections-page':
    URL_INSIGHTS_PORTAL_MERCHANDISING_COLLECTIONS_PAGE,

  'insights-portal-marketing-campaigns-analytics-overview':
    URL_INSIGHTS_PORTAL_MARKETING_CAMPAIGNS_OVERVIEW,
  'insights-portal-marketing-campaigns-analytics-redemptions-in-app':
    URL_INSIGHTS_PORTAL_MARKETING_CAMPAIGNS_REDEMPTIONS_IN_APP,
  'insights-portal-marketing-campaigns-analytics-user-growth':
    URL_INSIGHTS_PORTAL_MARKETING_CAMPAIGNS_USER_GROWTH,
  'insights-portal-marketing-campaigns-analytics-basket-impact':
    URL_INSIGHTS_PORTAL_MARKETING_CAMPAIGNS_BASKET,

  'insights-portal-marketing-awareness-campaigns-analytics-overview':
    URL_INSIGHTS_PORTAL_MARKETING_AWARENESS_CAMPAIGNS_OVERVIEW,
  'insights-portal-marketing-awareness-campaigns-analytics-basket-impact':
    URL_INSIGHTS_PORTAL_MARKETING_AWARENESS_CAMPAIGNS_BASKET_IMPACT,
  'insights-portal-marketing-awareness-campaigns-analytics-funnel-data':
    URL_INSIGHTS_PORTAL_MARKETING_AWARENESS_CAMPAIGNS_FUNNEL_DATA,

  'insights-portal-marketing-flyers-overview': URL_INSIGHTS_PORTAL_MARKETING_FLYERS_OVERVIEW,
  'insights-portal-marketing-flyers-single-flyer':
    URL_INSIGHTS_PORTAL_MARKETING_FLYERS_SINGLE_FLYER,

  'insights-portal-placements-insights': URL_INSIGHTS_PORTAL_PLACEMENTS_INSIGHTS,

  'insights-portal-reports-logs-custom-report-list':
    URL_INSIGHTS_PORTAL_REPORTS_LOGS_CUSTOM_REPORT_LIST,
  'insights-portal-reports-logs-custom-report-exports-list':
    URL_INSIGHTS_PORTAL_REPORTS_LOGS_CUSTOM_REPORT_EXPORTS_LIST,
  'insights-portal-reports-logs-custom-report-preview':
    URL_INSIGHTS_PORTAL_REPORTS_LOGS_CUSTOM_REPORT_PREVIEW,

  'insights-portal-ads-dashboard': URL_INSIGHTS_PORTAL_ADS_DASHBOARD,
  'insights-portal-sponsored-product-ads-dashboard':
    URL_INSIGHTS_PORTAL_SPONSORED_PRODUCT_ADS_DASHBOARD,
  'insights-portal-display-ads-dashboard': URL_INSIGHTS_PORTAL_DISPLAY_ADS_DASHBOARD,
  'insights-portal-overview-ads-dashboard': URL_INSIGHTS_PORTAL_OVERVIEW_ADS_DASHBOARD,
  'insights-portal-display-preview-blocking-tool':
    URL_INSIGHTS_PORTAL_DISPLAY_PREVIEW_BLOCKING_TOOL,

  'insights-portal-store-labor-performance-v2': URL_INSIGHTS_PORTAL_STORE_LABOR_PERFORMANCE_V2,

  'insights-portal-cart-assistant-dashboard': URL_INSIGHTS_PORTAL_CART_ASSISTANT_DASHBOARD,

  'insights-portal-caper-reporting-dashboard': URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD,
  'insights-portal-caper-reporting-dashboard-overview':
    URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_OVERVIEW,
  'insights-portal-caper-reporting-dashboard-sessions':
    URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_SESSIONS,
  'insights-portal-caper-reporting-dashboard-session-trends':
    URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_SESSION_TRENDS,
  'insights-portal-caper-reporting-dashboard-store-trend':
    URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_STORE_TREND,
  'insights-portal-caper-reporting-dashboard-audits':
    URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_AUDITS,
  'insights-portal-caper-reporting-dashboard-loyalty':
    URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_LOYALTY,
  'insights-portal-caper-reporting-dashboard-operations':
    URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_OPERATIONS,
  'insights-portal-caper-reporting-dashboard-store-performance':
    URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_STORE_PERFORMANCE,
  'insights-portal-caper-reporting-dashboard-session-details':
    URL_INSIGHTS_PORTAL_CAPER_REPORTING_DASHBOARD_SESSION_DETAILS,

  'insights-portal-delivery-performance': URL_INSIGHTS_PORTAL_DELIVERY_PERFORMANCE,
  'insights-portal-delivery-performance-overview':
    URL_INSIGHTS_PORTAL_DELIVERY_PERFORMANCE_OVERVIEW,
  'insights-portal-delivery-performance-delivery':
    URL_INSIGHTS_PORTAL_DELIVERY_PERFORMANCE_DELIVERY,

  'insights-portal-offer-ingestion': URL_INSIGHTS_PORTAL_OFFER_INGESTION,
  'insights-portal-offer-ingestion-summary': URL_INSIGHTS_PORTAL_OFFER_INGESTION_SUMMARY,
  'insights-portal-offer-ingestion-search': URL_INSIGHTS_PORTAL_OFFER_INGESTION_SEARCH,
  'insights-portal-offer-ingestion-supported-offers':
    URL_INSIGHTS_PORTAL_OFFER_INGESTION_SUPPORTED_OFFERS,
  'insights-portal-delivery-orchestration-performance':
    URL_INSIGHTS_PORTAL_DELIVERY_ORCHESTRATION_PERFORMANCE,
  'insights-portal-delivery-orchestration-provider-drilldown':
    URL_INSIGHTS_PORTAL_DELIVERY_ORCHESTRATION_PROVIDER_DRILLDOWN,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
